import { Routes, Route } from 'react-router-dom'
import Home from '../pages/home/Home'
import Servicios from '../pages/servicios/Servicios'
import Nosotros from '../pages/nosotros/Nosotros'
import Contacto from '../pages/contacto/Contacto'
import Privacidad from '../pages/privacidad/Privacidad'
import Terminos from '../pages/terminos/Terminos'
import NotFound from '../pages/notfound/NotFound'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

const AppRoutes = () => {
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}

export default AppRoutes
